module.exports = __webpack_public_path__ + "media/src/assets/wakesurf-ecd9a24bd9080275657702fabbdc9820.png";